<template>
<section v-loading="loading" class="wrapper">
  <router-view class="wrapper" />
</section>
</template>

<script>
import {mapGetters} from 'vuex'

import * as EventKeyMap from './EventKeys'

import {getRouteByModuleIds} from './router/routes'

import Login from './views/Profile/Login'

export default {
  name: 'App',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      userToken: 'Profile/token',
      navList: 'Profile/navList'
    })
  },
  methods: {
    handleRedirect (token) {
      let route = this.$route
      let currentRouteName = route.name

      if (token) {
        this.requestProfile(token, route.query.to)
      } else if (currentRouteName !== Login.name) {
        this.redirectToLogin()
      }
    },
    redirectToLogin () {
      location.replace('#/login')
      location.reload()
    },
    requestProfile (token, to) {
      this.$api.Profile.getProfile().then(data => {
        let moduleIds = data.moduleIds

        this.$store.commit('Profile/setAccountInfo', {
          ...data,
          permissions: moduleIds
        })

        this.addRoute(moduleIds)
      }).catch(error => {
        console.error(error)

        if (error.code === 408) {
          this.$store.commit('Profile/removeToken')
        }
      })
    },
    addRoute (moduleIds) {
      let route = getRouteByModuleIds(moduleIds)
      let router = this.$router

      this.$store.commit('Profile/setNavList', route.children)
      router.addRoute(route)

      if (/^\/(login)?$/.test(this.$route.path)) {
        router.replace(this.getFirstRoute(this.navList[0]))
      }
    },
    getFirstRoute (route) {
      for (let children = route.children; Array.isArray(children) && children.filter(route => route.isNav).length > 0;) {
        route = children[0]
        children = route.children
      }

      return route
    },
    err417 (message) {
      this.$notify({
        title: '错误',
        message,
        type: 'error',
        position: 'bottom-right'
      })
    },
    err408 (message) {
      this.$store.commit('Profile/removeToken')
    },
    err500 (message) {
      this.err417(message)
    },
    onResponseError (error) {
      let method = this[`err${error.code}`]
      method && method(error.message)
    },
    handleChangeLoadingStatus (flag) {
      this.loading = flag
    }
  },
  watch: {
    userToken: {
      immediate: true,
      handler (newVal) {
        this.handleRedirect(newVal)
      }
    }
  },
  created () {
    let eventBus = this.$eventBus
    eventBus.on(EventKeyMap.RESPONSE_ERROR, this.onResponseError)
    eventBus.on(EventKeyMap.CHANGE_LOADING_STATUS, this.handleChangeLoadingStatus)
  },
  beforeDestroy () {
    let eventBus = this.$eventBus
    eventBus.off(EventKeyMap.RESPONSE_ERROR, this.onResponseError)
    eventBus.off(EventKeyMap.CHANGE_LOADING_STATUS, this.handleChangeLoadingStatus)
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue